module.exports = __webpack_public_path__ + "static/img/loading-spokes.095b9803.svg";